import { Table } from '@app/domain/Table'

export class POSTableMappingItem {
    constructor(
        public id: string,
        public table: Table,
        public extTableRef: string,
    ) {
    }
}
